import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import './Header.css'
import './Custom.css'
import { Link } from 'react-router-dom'

function DropdownMenu() {
  return (
    <Dropdown className="drop-down">
      <Dropdown.Toggle id="dropdown-button-dark" variant="outline-light">
        <FontAwesomeIcon className="bar-icon" icon={faBars} size="2xl" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="drop__downMenu" variant="black">
        <h1 className="category__intro">Kategorier</h1>
        <Dropdown.Divider />
        <Dropdown.Item as={Link} className="drop__downItem drop__link" to="/hot-wheels">
          Hot Wheels
        </Dropdown.Item>
        <Dropdown.Divider />

        <Dropdown.Item as={Link} className="drop__downItem drop__link" to="/lego-bilar">
          LEGO Bilar
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Item as={Link} className="drop__downItem drop__link" to="/siku-bilar">
          Siku Bilar
        </Dropdown.Item>

        <Dropdown.Divider className="last_divider" />

        <Dropdown.Item as={Link} className="drop__downItem drop__link" to="/rc-bilar">
          RC Bilar
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DropdownMenu
